module.exports = __webpack_public_path__ + "files/cd14401ebe62877674d043945a2e253e.png";